import { render, staticRenderFns } from "./SfColor.vue?vue&type=template&id=17972885&functional=true&"
import script from "./SfColor.vue?vue&type=script&lang=js&"
export * from "./SfColor.vue?vue&type=script&lang=js&"
import style0 from "./SfColor.vue?vue&type=style&index=0&id=17972885&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports